"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgTwitterCircle(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({}, props, {
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    className: "Icon ".concat(props.className ? props.className : ''),
    ref: svgRef
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 0C229.2 0 0 229.2 0 512s229.2 512 512 512 512-229.2 512-512S794.8 0 512 0zm238 362.3c-2.2 3.6-13.3 16.2-25.1 27.8-20 19.9-21.1 22.1-21.1 38.7 0 25.7-12.2 79.2-24.4 108.5-22.6 55-71 111.7-119.3 140.3-68 40.2-158.6 50.3-234.9 26.8-25.4-7.9-69.1-28.2-69.1-31.8 0-1.1 13.3-2.5 29.4-2.9 33.7-.8 66.7-10 96-26.8l19.3-11.6-22.2-7.6c-31.5-10.9-59.8-35.8-67-59.3-2.2-7.6-1.5-8 18.6-8l20.8-.4-17.5-8.3c-20.8-10.5-39.8-28.2-49.1-46.3-6.8-13-15.4-45.9-12.9-48.4.7-1.1 8.2 1.1 16.8 4 24.7 9.1 27.9 6.9 13.6-8.3-26.9-27.5-35.1-68.3-22.2-107l6.1-17.4 23.6 23.5c48.4 47.4 105.3 75.6 170.5 83.9l17.9 2.2-1.1-17.7c-3.3-46 25-87.9 70.1-104.2 16.5-5.7 44.4-6.5 62.7-1.4 7.1 2.2 20.7 9.4 30.4 15.9l17.5 11.9 19.3-6.1c10.7-3.3 25.4-9 31.5-12.3s11.5-5.1 11.5-4c0 6.2-13.3 27.1-24.4 38.7-15 16.3-10.7 17.7 19.7 6.9 18.2-6.2 18.6-6.2 15 .7z"
  }));
}

var ForwardRef = React.forwardRef(SvgTwitterCircle);
var _default = ForwardRef;
exports.default = _default;